import { render } from "./System.vue?vue&type=template&id=75c51b59"
import script from "./System.vue?vue&type=script&lang=js"
export * from "./System.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__